import { combineReducers } from 'redux'
import merge from 'lodash/merge'

import { RECEIVE_SETTING } from '../actions/setting-actions.js'

const setting = (state = {}, action) => {
  switch(action.type) {
    case RECEIVE_SETTING: return merge({}, state, action.setting)
    default: return state
  }
}

export default combineReducers( {
  setting
})
